// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MachineLearningStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import fetcher from 'fetchers/Izenda.MLSettingsFetcher';
import nlqfetcher from 'fetchers/Izenda.NLQFetcher';
import MLSettingsModel from './models/Izenda.MLSettings';
import { action, computed, observable } from 'mobx';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import dataFetcher from 'fetchers/Izenda.ConnectionStringDataFetcher';
import uiState from 'logic/Izenda.UiState.js';
/**
 * Izenda machine learning view model store.
 */
export default class MachineLearningStore {
  @observable model = null;
  @observable clonedModel = null;
  @observable alertDetails = new AlertDetails();
  @observable nlqConfigurationModel;

  constructor() {
    this.init();
  }

  /**
   * @property canSaveMLSettings
   * @description computed boolean that returns true if both the ML server and
   * ML db connection tests are successful
   */
  @computed get canSaveMLSettings() {
    return this.model.predictionServerStatus &&
      this.model.predictionServerStatus.success;
  }

  /**
 * @property canSaveNLQSettings
 * @description computed boolean that returns true if the ML server
 *  tests are successful
 */
  @computed get canSaveNLQSettings() {
    return this.model.predictionServerStatus &&
      this.model.predictionServerStatus.success;
  }

  @action
  init() {
    this.model = new MLSettingsModel();
    this.clonedModel = this.model.clone();
  }

  @action
  checkPredictionServerStatus(ipAddress) {
    return fetcher.checkMLServerSettings(ipAddress);
  }

  @action
  checkMLDBStatus(ConnectionString, ipAdd) {
    return fetcher.checkMLDBSettings(ConnectionString, ipAdd);
  }

  @action
  saveMLSettings() {
    const settingsVariable = {
      ServerIp: ''
    };
    settingsVariable.ServerIp = this.model.mlServerIp;
    return fetcher.saveMLSettings(settingsVariable).then((result) => {
      let resultinJson = typeof result === 'object' ? result : JSON.parse(result);
      return resultinJson;
    });
  }
  /**
     * @method getpredictionServerDetails
     * @description update NLQ ML server IP address
     * @return {Promise}
     */
  @action
  saveMLNLQSettings() {
    const nlqSettingsVariable = {
      ServerIp: ''
    };
    nlqSettingsVariable.ServerIp = this.model.mlServerIp;
    return fetcher.saveMLNLQSettings(nlqSettingsVariable).then((result) => {        
      return result;
    });
  }
  /**
   * @method getpredictionServerDetails
   * @description calls the ML servers settings api and sets the server IP based on what's returned
   * @return {Promise}
   */
  @action
  getpredictionServerDetails() {
    return fetcher.getMLSettingsDetail().then((data) => {
      if (data) {
        this.model.predictionServerSuccess = true;
      }
      this.model.mlServerIp = data.perdictionServerIP;
    });
  }

  /**
   * @method getMLDBsettings
   * @description call dbSettingsDetail api to get dbSettings and sets the db success status
   * and connection string or the error message when the fetch returns
   * @return {Promise}
   */
  @action
  getMLDBsettings() {
    return fetcher.getDBSettingsDetail().then((data) => {
      if (typeof data === 'string') {
        data = data == '' ? { success: false } : JSON.parse(data);
      }
      if (data.success) {
        this.model.dbServerSuccess = true;
        this.model.dbConnectionStringInput = data.ConnectionString;
      }
      this.model.dbServerHasLoaded = true;
    });
  }
  @action
  saveConfigureforNLQ(connectionId, searchMode) {
    return nlqfetcher.saveConfigureforNLQ(connectionId, uiState.getTenantId(), searchMode);
  }
  @action
  ResetNLQ(searchMode) {
    return nlqfetcher.resetNLQ(uiState.getTenantId(),searchMode);
  }
  @action
  getAllConnectionString() {
    return dataFetcher.getAllConnectionString(uiState.getTenantId());
  }

  @action
  getConfigureNLQStatus() {
    return nlqfetcher.getConfigureNLQStatus(uiState.getTenantId());
  }
  @action
  switchConfigureforSearchMode(connectionId, searchMode) {
    return nlqfetcher.switchConfigureforSearchMode(connectionId, uiState.getTenantId(), searchMode);
  }


}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.MachineLearningStore.js